export const ChartCheckbox = ({ label, checked, onChange, isAll }) => (
  <label className="flex items-center space-x-2 text-[#EEEEEE]">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="form-checkbox text-[#306AF6]"
    />
    <span>{isAll ? <strong>{label}</strong> : label}</span>
  </label>
);
